import { useQuery } from "@tanstack/react-query";
import { getLiabilityReports } from "../../service/query/auth";

export const useGetLiabilityReport = ({ payload}) => {
  const liabilityReport= useQuery({
    queryKey: ['liabilityReport', payload],
    queryFn: () => getLiabilityReports({ ...payload }),
    enabled: !!payload,
    keepPreviousData: true,
  },
  
  

);
  return {data:liabilityReport?.data?.data,  ...liabilityReport,}
};